import {
  getTailwindColor,
  getTitledHexColorOption,
  HexColor,
  mapProductColor,
} from '@gn-audio/jss-components';
import { Attribute, FamilyGroup } from '@gn-audio/jss-core';
import { Option } from '@gn-audio/jss-core/common/models';

import { ColorHexMapping } from 'api/colorHexMappingApi';
import { getBrandColorName, getProductColorHex } from 'common/utils/attributeUtils';

export const DEFAULT_PRODUCT_BRAND_COLOR = 'beige';

export enum GroupAttributeKeys {
  COLOR_HEX = 'Product_Mobcolorhex',
  META_BUY_PAGE_URL = 'Meta_BuyPageUrl',
  LIFESTYLE_IMAGE = 'Product_BrandLifestyleImagePublicWeb',
}

export const getAttributeByKey = (attributes: Attribute[], key: string) =>
  attributes.find((attr) => attr.key === key);

/**
 * Retrieves a titled hex color option for a product based on its 'Product_Mobcolorhex' attribute and color hex mappings.
 *
 * @param attributes - An array of product attributes.
 * @param colorHexMappings - An array of color hex mappings.
 * @returns An `Option` object representing the titled hex color option, or `undefined` if the attribute is not found.
 */
export const getProductTitledHexColorOption = (
  attributes: Attribute[],
  colorHexMappings: ColorHexMapping[]
): Option | undefined => {
  const attribute = getAttributeByKey(attributes, GroupAttributeKeys.COLOR_HEX);
  if (!attribute) return;

  return getTitledHexColorOption(attribute.value, colorHexMappings, attribute.text) as Option;
};

export const getProductBuyPageUrl = (attributes: Attribute[]): string | undefined => {
  const attribute = getAttributeByKey(attributes, GroupAttributeKeys.META_BUY_PAGE_URL);
  return attribute?.value;
};

export const getBackgroundColorHex = (
  currentGroup?: FamilyGroup,
  defaultBgColor = DEFAULT_PRODUCT_BRAND_COLOR
): HexColor | undefined => {
  if (!currentGroup) return getTailwindColor(mapProductColor(defaultBgColor));

  const productColorHex = getProductColorHex(currentGroup);
  const brandColor = getBrandColorName(currentGroup);
  const brandColorHex = getTailwindColor(mapProductColor(brandColor || defaultBgColor));
  // todo: seems brandColorHex is always defined with defaultBgColor as fallback? why not just use brandColorHex?
  return brandColorHex ?? productColorHex;
};
